import React, { useState } from 'react';
import { IconButton, SvgIcon, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { renderToolbarIcon } from '../../../utils/renderToolbarIcon';
import { palette } from '../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../utils/getMuiIcon';
import AssistantSectionTopBar from '../../../components/PageToolbar/AssistantSectionTopBar';

const MyContentsTopBarContent: React.FC = () => {
  const { t } = useTranslation();
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <AssistantSectionTopBar
      rowSx={{ height: 24 }}
      icon={renderToolbarIcon('myContent', palette.text.primary, true, '0 0 24 24')}
      title={t('My Contents')}
      data-testid='my-contents-top-bar-content'
      trailing={
        <Tooltip
          title={t('All AI-created materials in one place')}
          arrow
          placement='bottom'
          open={tooltipOpen}
          onOpen={() => setTooltipOpen(true)}
          onClose={() => setTooltipOpen(false)}
        >
          <IconButton
            data-testid='info-icon-button'
            onClick={() => setTooltipOpen(true)}
            size='small'
            color='secondary'
            aria-label={t('Info')}
          >
            <SvgIcon
              component={getMuiIcon('infoCircle')}
              sx={{
                color: palette.text.disabled,
                width: 24,
                height: 24,
              }}
              viewBox='0 0 24 24'
            />
          </IconButton>
        </Tooltip>
      }
    />
  );
};

export default MyContentsTopBarContent;
